import { TechPartnersTable } from "@/components/settings/TechPartnersTable";
import { PageHeader } from "@/components/shared/page-header";

export function SettingsTechPartnersPage() {
  return (
    <div className="space-y-10">
      <section className="space-y-4">
        <PageHeader title="Tech Partners" />
        <TechPartnersTable />
      </section>
    </div>
  );
}
